import { Component, ErrorInfo, PropsWithChildren } from "react";
import { ErrorScreen } from "./ErrorScreen";

interface IState {
    hasError: boolean;
}

/** The app's last resort: an error nothing below caught. The details go to the console, not to the visitor. */
export class ErrorComponent extends Component<PropsWithChildren<{}>, IState> {
    state: IState = { hasError: false };

    static getDerivedStateFromError(): IState {
        return { hasError: true };
    }

    componentDidCatch(error: unknown, info: ErrorInfo) {
        console.error(error, info.componentStack);
    }

    render() {
        return this.state.hasError ? (
            <ErrorScreen
                title="Coś poszło nie tak"
                message="Wystąpił nieoczekiwany błąd. Odśwież stronę, a jeśli to nie pomoże, spróbuj później."
            />
        ) : (
            this.props.children
        );
    }
}
